import { Box } from '@jfs/ui-new'
import ActionsMenu from '../../comps/ActionMenu/ActionsMenu'
import Tabbar, { TabbarType } from '../../comps/Tabbar'
import styles from './styles'

const Tabs = ({
  path,
  tabIndex,
  bulkRefundTabData,
  setTabIndex,
  setFieldSettingVisible,
  onSearchTextChange,
  setFilterVisible,
  fetchDetailOfPath,
  selectedDateInfo,
  updateSelectedDate,
}: any) => {
  const themedStyle = styles(0)

  return (
    <Box flexDirection={'row'}>
      <Box {...themedStyle.tabbarweb}>
        <Tabbar
          default={tabIndex}
          titles={bulkRefundTabData}
          onSelected={setTabIndex}
          type={TabbarType.recentPayments}
        />
      </Box>
      {tabIndex === 1 && (
        <ActionsMenu
          path={path}
          fieldSettingVisible={false}
          setFieldSettingVisible={setFieldSettingVisible}
          filterVisible={false}
          onSearchTextChange={onSearchTextChange}
          setFilterVisible={setFilterVisible}
          fetchDetailOfPath={fetchDetailOfPath}
          selectedDateInfo={selectedDateInfo}
          updateSelectedDate={updateSelectedDate}
          maxRange={31}
        />
      )}
    </Box>
  )
}

export { Tabs }
